import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import parse from 'html-react-parser';

interface PropTypes {
  title: string;
  content: string;
  image?: string;
}

function MainSection(props: PropTypes): JSX.Element {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column'}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box>
            <Typography variant={'h4'} gutterBottom sx={{ fontWeight: 700 }}>
              {props.title}
            </Typography>

            <Typography component={'p'} variant="body1">
              {parse(props.content)}
            </Typography>
          </Box>
        </Grid>
        <Grid item container justifyContent="center" alignItems="center" xs={12} md={6}>
          <Box maxWidth={500} width={1}>
            {props.image && (
              <Box
                component={'img'}
                src={props.image}
                width={1}
                height={1}
                sx={{
                  filter: theme.palette.mode === 'dark' ? 'brightness(0.8)' : 'none',
                }}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default MainSection;
